import React, { Component } from 'react';
import ActiveIndicatorContainer from './ldapActiveIndicatorContainer';

export default class LdapServerMainDetails extends Component {

    shouldComponentUpdate(nextProps) {
        
        if (nextProps.name != this.props.name
                || nextProps.active != this.props.active) {
         
                return true;
        }

        return false;
    }

    render() {

        return(
            <div className='main-details'>
                <div className='server-name ellipsis'
                    title={this.props.name}>
                    {this.props.name}
                </div>
                <div className='active'>
                    <ActiveIndicatorContainer active={this.props.active} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/ldapServerMainDetails.jsx